export default "__VITE_ASSET__BkzLpyZZ__"